import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from 'edenred-ui';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { closeNotification } from '@epi-actions/companyAccounts';
import { ErrorPanel } from '@epi-components/ErrorPanel/ErrorPanel';
import { ApiConstants } from '@epi-constants/actions';
import { ILoadCompanyAccount } from '@epi-models/containers/LoadCompanyAccount';
import { getCompanyNotification } from '@epi-selectors/companyAccounts';
import { NotificationInfo } from '@epi-shared/components';
import { useGetTransferMoneyEstimationQuery } from '@epi-api/companyAccount';

import { useLoadCompanyAccount } from './hooks';
import {
  PaymentMethodOptions,
  ReviewRequestedLoads,
  TransferMoneyEnterAmount
} from './components';

const LoadCompanyAccount = ({ updateFooter }: ILoadCompanyAccount) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showNotification: boolean = useSelector(getCompanyNotification);
  const { data: estimation } = useGetTransferMoneyEstimationQuery();

  const {
    form,
    submitCompleteForm,
    disabled,
    isPaymentProcessing,
    handleSubmitForm
  } = useLoadCompanyAccount(updateFooter);

  const showReviewRequestedLoads =
    estimation?.requestedLoads &&
    estimation.requestedLoads.numberOfRequests > 0;

  return (
    <>
      <FormProvider {...form}>
        <form noValidate onSubmit={handleSubmitForm}>
          <Box pt={4} display={showNotification ? 'block' : 'none'}>
            <NotificationInfo
              text={t('containers.deposit_money.page_description')}
              onClose={() => dispatch(closeNotification())}
            />
          </Box>
          {showReviewRequestedLoads && (
            <ReviewRequestedLoads estimation={estimation} />
          )}
          <Box my={2}>
            <TransferMoneyEnterAmount />
          </Box>
          <PaymentMethodOptions
            submitCompleteForm={submitCompleteForm}
            disabled={disabled}
            isPaymentProcessing={isPaymentProcessing}
          />
        </form>
      </FormProvider>
      <ErrorPanel failedActionName={ApiConstants.DEPOSIT_COMPANY_ACCOUNT} />
    </>
  );
};

export { LoadCompanyAccount };
